import script from "./DragAndDropDivCompo.vue?vue&type=script&setup=true&lang=js"
export * from "./DragAndDropDivCompo.vue?vue&type=script&setup=true&lang=js"

import "./DragAndDropDivCompo.vue?vue&type=style&index=0&id=823141fe&lang=css"

const __exports__ = script;

export default __exports__